import { render, staticRenderFns } from "./AppAlertsCoaAlertsConfigComposite.vue?vue&type=template&id=71c6e263&scoped=true&"
import script from "./AppAlertsCoaAlertsConfigComposite.vue?vue&type=script&lang=js&"
export * from "./AppAlertsCoaAlertsConfigComposite.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsCoaAlertsConfigComposite.vue?vue&type=style&index=0&id=71c6e263&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c6e263",
  null
  
)

export default component.exports